const adminPageClasses = {
  container: 'flex flex-col items-center mx-auto gap-4 py-12 lg:py-8 lg:my-16',
  heading: 'text-3xl font-semibold mb-4',
  addMovie: 'text-md font-semibold text-slate-400',
  input: 'border p-2 mb-8  bg-slate-800 border-slate-700 md:w-1/2 xl:w-1/5',
  movieHeader: 'text-2xl font-semibold text-slate-400',
  moviesContainer: 'flex h-full flex-wrap justify-center w-screen gap-8',
  moviesContainer2:
    'flex flex-col border bg-slate-800 border-slate-700 rounded-lg items-center p-6 gap-2 justify-between drop-shadow-lg text-slate-400',
  delete: 'flex justify-between w-full',
  link: 'group flex flex-col justify-center items-center h-full w-full',
  image:
    'object-contain w-full rounded-3xl group-hover:brightness-50 border border-slate-700',
  infoContainer: 'flex items-center justify-between w-full',
  infoContainer2: 'flex flex-col justify-end items-start px-2',
  title: 'text-2xl text-white font-semibold',
}

export default adminPageClasses
